module.exports = __webpack_public_path__ + "284ddb51d32fb5e1a8213b6666a9a007.svg";